// Copyright 2021-present 650 Industries (Expo). All rights reserved.

import { createExoticTransformer } from './createExoticTransformer';

module.exports = createExoticTransformer({ nodeModulesPaths: ['node_modules'] });
